
import React, { useRef, useEffect, useMemo } from 'react';
import { DeviceUtil } from 'utils/deviceUtil';

const BaseballCountAnimate = ({ count, type, isMatch }) => {
  const isIE = DeviceUtil.isIE();
  const countRef = new Array(count).fill(useRef());
  const translate = isMatch ? `translate(-19, -7)` : `translate(-13, -2)`;
  const d = isMatch ? 10 : 8;
  const r = d / 2;
  const circleX = isMatch ? 2 : 1;

  useEffect(() => {
    if (!isIE) {
      if (count > 0) {
        if (!!countRef[count - 1]) {
          if (!!countRef[count - 1].current) {
            countRef[count - 1].current.beginElement();
          }
        }
      }
    }
  }, [count]);

  const color = useMemo(() => {
    switch (type) {
      case 'ball':
        return '#28d720';

      case 'strike':
        return '#ffe402';

      case 'out':
        return '#ef1a22';

      default:
        return '#28d720';
    }
  }, [type]);

  return (
    <g transform={translate}>
      {new Array(count).fill('').map((item, idx) => {
        const space = isMatch ? 14 : 9;
        const index = idx + 1;
        const width = index * space;

        return (
          <circle
            key={idx}
            transform={`translate(${width}, ${circleX})`}
            cx={d}
            cy={d}
            r={r}
            fill={color}>
            <animate
              ref={countRef[idx]}
              restart="always"
              attributeName="opacity"
              dur="0.5s"
              from={0}
              to={1}
              repeatCount="3"
            />
          </circle>
        );
      })}
    </g>
  );
};

export default BaseballCountAnimate;
